const scrollTop = () => {
  if (window === 'undefined') return;
  window.scrollTo(0, 0);
};

export default scrollTop;
